export const iconFontAwesomeMedicalHealthHeartCircleBolt = (
	<i className="fa-solid fa-heart-circle-bolt"></i>
);
